 <template>
  <div class="my_dialog">
    <!--外层的遮罩 点击事件用来关闭弹窗，isShow控制弹窗显示 隐藏的props-->
    <!-- <div class="dialog-cover" v-if="pre_show" @click="closeMyself"></div> -->
    <!-- transition 这里可以加一些简单的动画效果 -->
    <transition name="drop">
      <!--style 通过props 控制内容的样式  -->
      <div class="dialog-content" v-if="pre_show">
        <div :class="pre_showtype">
          <!--弹窗头部 title-->
          <slot name="header">{{ pre_title }}</slot>
        </div>
        <div class="dialog_maintext">
          <!--弹窗的内容-->
          <div><textarea v-model="pre_note"></textarea></div>
          <div>
            <button
              v-show="show_yes"
              @click="refresh_data('1')"
              class="btn_yes"
            >
              {{ pre_btn_yes }}
            </button>
            <button v-show="show_no" @click="refresh_data('2')" class="btn_no">
              {{ pre_btn_no }}
            </button>
            <button
              v-show="show_canel"
              @click="refresh_data('3')"
              class="btn_can"
            >
              {{ pre_btn_cancel }}
            </button>
          </div>
          <!-- <div v-show="show_note" ><span>留言不能超过100字</span></div> -->
        </div>
        <!--弹窗关闭按钮-->
        <div class="foot_close" @click="closeMyself">
          <div class="close_img back"></div>
        </div>
      </div>
    </transition>
  </div>
</template> 

<script>
/*
名称：弹窗组件 录入框
日期：2019-03-14
作者：hj
步骤：
先搭建组件的html和css样式，遮罩层和内容层。
调用：


*/
export default {
  /*组件名称不能和系统关键字重复*/ 
  name: "pre_message_text",
  data() {
    return {
      pre_show:false,
      pre_showtype:'dialog_head dialog_head_none',
      pre_text:'',
      pre_seconde:1,
      pre_note:'',
      pre_btn_yes:'',
      pre_btn_no:'',
      pre_btn_cancel:'',
      pre_back_type:'',
      show_yes:true,
      show_no:true,
      show_canel:true,
      show_note:true,
    }
  },
  props: {            
    showtype:{
      type:String,
      default:''
    },
    // 标题
    title:{
      type:String,
      default:''
    },
    // 按钮1
    btn1:{
      type:String,
      default:''
    },
    // 按钮2
    btn2:{
      type:String,
      default:''
    },
    // 标题3
    btn3:{
      type:String,
      default:''
    },
    message_data: {
      type: Object,
      default: function () {
        return { showtype: 'dialog_head dialog_head_none',note:'对象模式' }
      }
    }
  },
  watch:{    
    // note(val){
    //   this.my_note=val;
    //   // console.log('展示'+this.note+' my_note='+this.my_note);
    //   this.refresh_data();
    // },
    message_data(obj){
      this.check_obj();
    }
  },
  methods: {
    closeMyself() {
      this.pre_show=false;
    },
    refresh_data:function(type){
      // console.log(' pre_back_type ='+this.pre_back_type);
      switch(type){
        case '1':
          this.$emit("msg-event", this.pre_note,'YES',this.pre_back_type);
          break;
        case '2':
        this.$emit("msg-event", this.pre_note,'NO',this.pre_back_type);
          break;
        case '3':
          break;
          this.pre_show=false;
        default:
          alert('异常操作='+type);
          break;
      }
      this.pre_show=false;
    },
    check_obj:function(){
      // console.log('传入');
      // console.log(this.message_data);
      // 展示类型 1个按钮 yes  2个按钮 yes no  3个按钮 yes no canel
      this.show_yes=false;
      this.show_no=false;
      this.show_canel=false;
      this.show_note=true;
      this.pre_note='';
      this.pre_back_type='';
      switch(this.message_data.showtype){
        case '1':
          this.show_yes=true;
          
          break;
        case '2':
          // 是否操作提示
          this.show_yes=true;
          this.show_canel=true;
          this.pre_btn_cancel=this.message_data.btn3;
          this.show_note=false;
          break;
        case '3':
          // 是否操作提示
          this.show_yes=true;          
          this.show_canel=true;
          this.pre_btn_cancel=this.message_data.btn3;
          break;
        case '4':
          // 留言
          this.show_yes=true;          
          this.show_canel=true;
          this.pre_btn_cancel=this.message_data.btn3;
          break;
        default:
          break;
      }
      this.pre_title=this.message_data.title;
      this.pre_btn_yes=this.message_data.btn1;
      this.pre_note=this.message_data.note;
      this.pre_back_type=this.message_data.back_type;
      this.pre_show=true;
    }
  }
};
</script>


<style scoped>
/*
scss 依赖安装
npm  install -s sass-loader
npm install -s node-sass
*/
/** 弹窗动画*/
.drop-enter-active {
  /* // 动画进入过程：0.5s */
  transition: all 0.5s ease;
}
.drop-leave-active {
  /* // 动画离开过程：0.5s */
  transition: all 0.3s ease;
}
.drop-enter {
  /* //动画之前的位置 */
  transform: translateY(-500px);
}
.drop-leave-active {
  /* //动画之后的位置 */
  transform: translateY(-500px);
}
/* // 最外层 设置position定位 */
.my_dialog {
  position: relative;
  color: #2e2c2d;
  font-size: 16px;
}
/* // 遮罩 设置背景层，z-index值要足够大确保能覆盖，高度 宽度设置满 做到全屏遮罩 */
.dialog-cover {
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  z-index: 200;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
/* // 内容层 z-index要比遮罩大，否则会被遮盖， */
.dialog-content {
  position: fixed;
  width: 40%;
  top: 36%;
  left: 30%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 300;
  background: #e4dddd;
  /* // box-shadow: 5px 5px 5px  #c6cac89f; */

  .dialog_head {
    /* // 头部title的背景 居中圆角等属性。 */
    /* // width: 86.5%; */
    width: 100%;
    height: 43px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    padding: 5px 50px 10px 50px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background: #e4dddd;
  }
  .dialog_head_ok {
    background-color: #45f79f;
  }
  .dialog_head_no {
    background-color: #72837a;
  }
  .dialog_head_warning {
    background-color: #f4fb8e;
  }
  .dialog_head_err {
    background-color: #f31b2a;
  }
  .dialog_head_none {
    background-color: #e4dddd;
  }
  .dialog_main {
    /* // 主体内容样式设置 */
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-content: center;
    /* // width: 86.5%; */
    width: 100%;
    padding: 22px 50px 47px 50px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  .foot_close {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #fcca03;
    display: flex;
    justify-content: center;
    align-content: center;
    position: absolute;
    right: -60px;
    top: -6px;
    .close_img {
      background-image: url("../../assets/image/shan1.png");
      width: 20px;
      height: 20px;
    }
  }
}

/* 录入框样式 */
.dialog_maintext {
  background: #e4dddd;
  text-align: center;
  justify-content: center;
  align-content: center;
  /* // width: 86.5%; */
  width: 100%;
  padding: 22px 50px 47px 50px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.dialog_maintext > div > {
  text-align: center;
}

.dialog_maintext > div > textarea {
  width: 100%;
  height: 90px;
  border-radius: 5px 5px 5px 5px;
}
.tinput {
  border: 0px;
}

.dialog_maintext > div > button {
  border-radius: 3px;
  height: 28px;
  width: 120px;
  margin-top: 10px;
  padding: 1px 2px 2px 2px;
}
.dialog_maintext > div > button:hover {
  background-color: rgba(155, 222, 231, 0.986);
  cursor: pointer;
}

.dialog_maintext > div > span {
  color: red;
  font-size: 12px;
}

.btn_yes {
  background-color: rgba(171, 238, 177, 0.986);
}
.btn_can {
  background-color: rgba(234, 248, 246, 0.986);
}
.btn_no {
  background-color: rgba(236, 26, 26, 0.986);
}
</style>
